export default __webpack_public_path__ + "static/women_1-fd4a08dcea97d9223ecf667dfbd4cf63.webp";